import React, { useState, useRef, useEffect } from 'react';
import ScrollableArea from '../scrollbar/ScrollableArea';
import PickList from './PickList';
import Flex from '../containers/Flex';
import ScrollbarSvg from '../scrollbar/ScrollbarSvg';
import { boxShadow, border } from '../styles';

const headerOffset = 27;

const scrollbarContainerStyle = {
    boxSizing: 'border-box',
    flexDirection: 'column',
    backgroundColor: '#ffffff'
};

const ScrollablePickList = ({
    types,
    data,
    setData,
    maxItems,
    height,
    width = '100%',
    style,
    keyToDisplay
}) => {
    const pickListRef = useRef(null);
    const containerRef = useRef(null);
    const gutterRef = useRef(null);

    height =
        gutterRef?.current?.clientHeight < height
            ? gutterRef?.current?.clientHeight
            : height;

    const [scrollPx, setScrollPx] = useState(0);
    const [scrollableHeight, setScrollableHeight] = useState(0);
    const [gutterOffsetTop, setGutterOffsetTop] = useState(0);
    const [maxVisibleHeight, setMaxVisibleHeight] = useState(height);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (pickListRef?.current?.scrollHeight !== scrollableHeight) {
            setScrollableHeight(pickListRef?.current?.scrollHeight || 0);
        }
        setGutterOffsetTop(
            (pickListRef?.current?.offsetTop || 0) +
                (pickListRef?.current?.offsetParent?.offsetTop || 0) +
                headerOffset
        );
        setMaxVisibleHeight(scrollableHeight?.current?.clientHeight || height);
        setContainerWidth(containerRef?.current?.clientWidth || 0);
    }, [
        pickListRef?.current?.scrollHeight,
        containerRef?.current?.clientHeight,
        containerRef?.current?.clientWidth,
        data.length
    ]);

    return (
        <Flex style={{ flexDirection: 'column', width: '100%' }}>
            <ScrollableArea
                id='pick-list-scrollable-area'
                ref={containerRef}
                onScroll={setScrollPx}
                scrollPx={scrollPx}
                width={width}
                height={height}
                scrollSpeed={16}
                scrollableLength={scrollableHeight}
            >
                <Flex style={{ width: '100%' }}>
                    <PickList
                        ref={pickListRef}
                        types={types}
                        data={data}
                        setData={setData}
                        maxItems={maxItems}
                        style={{
                            ...style,
                            position: 'relative',
                            bottom: scrollPx,
                            width: '100%'
                        }}
                        headerStyle={{
                            position: 'relative',
                            top: scrollPx,
                            backgroundColor: '#ffffff',
                            boxShadow: scrollPx > 0 ? boxShadow : undefined
                        }}
                        maxVisibleLength={maxVisibleHeight}
                        keyToDisplay={keyToDisplay}
                    />
                    <Flex
                        id='pick-list-scrollbar-container'
                        style={scrollbarContainerStyle}
                    >
                        <div
                            id='pick-list-scrollbar-gutter-cap'
                            style={{
                                boxSizing: 'border-box',
                                height: headerOffset,
                                backgroundColor: '#ffffff',
                                zIndex: 20,
                                borderBottom: border
                            }}
                        />
                        <div
                            id='pick-list-scrollbar-gutter'
                            ref={gutterRef}
                            style={{
                                boxSizing: 'border-box',
                                border: border,
                                borderTop: 0,
                                height: 'calc(100% - 27px)'
                            }}
                        >
                            <ScrollbarSvg
                                id='pick-list-scrollbar'
                                onScroll={setScrollPx}
                                scrollPx={scrollPx}
                                gutterOffset={gutterOffsetTop}
                                scrollableLength={
                                    scrollableHeight - headerOffset
                                }
                                maxVisibleLength={
                                    maxVisibleHeight - headerOffset
                                }
                            />
                        </div>
                    </Flex>
                </Flex>
            </ScrollableArea>
            <div
                id='pick-list-footer'
                style={{
                    boxSizing: 'border-box',
                    height: 11,
                    border: border,
                    backgroundColor: '#ffffff',
                    width: containerWidth
                }}
            />
        </Flex>
    );
};

export default ScrollablePickList;
